<div *ngIf="subject" class="colored-header">
  <h2>
    {{ subject.subjectDescr }}
  </h2>

  <button *ngIf="!editSw" class="btn-editUser" (click)="editSw = true"></button>

  <button *ngIf="editSw" (click)="save()" class="t-button-outline">
    {{ "translate.general.save" | translate }}
  </button>
</div>
<div class="t-widget--noPadding param-box">
  <div *ngFor="let p of subject.params" class="summary-row allow-hover" >
    <p class="lbl">{{ p.descr }}</p>
    <p *ngIf="!editSw" class="value l-ltr">{{ p.value }}</p>
    <p-inputNumber
      class="l-ltr"
      [class.dirty]="p.dirtySw"
      *ngIf="editSw"
      [(ngModel)]="p.value"
      mode="decimal"
      [showButtons]="true"
      [min]="subject.min"
      [max]="subject.max"
      (ngModelChange)="onValueChanged(p)"
    >
    </p-inputNumber>
  </div>
</div>
